import { IMenuItem } from 'src/app/layout/navigation/models/nav-item.model';
import { ACE_INSIGHTS_CLAIMS, EClaimsGroup } from '../claims.config';
import {
  INSIGHTS_CONFIGURATION_ROUTES,
  INSIGHTS_REPORTS_ROUTES,
  INSIGHTS_ROOT_ROUTES,
  INSIGHTS_SYSTEM_ROUTES,
  INSIGHTS_TOOLS_ROUTES,
  ROOT_ROUTES,
} from '../router.config';

export const INSIGHTS_NAVIGATION_CONFIG: IMenuItem[] = [
  {
    label: 'Tools',
    expanded: true,
    claimGroupName: EClaimsGroup.aceInsights,
    items: [
      {
        label: 'Scorecard Challenges',
        routerLink: `/${ROOT_ROUTES.aceInsights}/${INSIGHTS_ROOT_ROUTES.tools}/${INSIGHTS_TOOLS_ROUTES.scorecardChallenges}`,
        claimName: ACE_INSIGHTS_CLAIMS.ACEInsightsScorecardChallengesRead,
      },
      {
        label: 'Unidentified Agent Calls',
        routerLink: `/${ROOT_ROUTES.aceInsights}/${INSIGHTS_ROOT_ROUTES.tools}/${INSIGHTS_TOOLS_ROUTES.unidentifiedAgentCalls}`,
        claimName: ACE_INSIGHTS_CLAIMS.ACEInsightsExternalUserRead,
      },
    ],
  },
  {
    label: 'Configuration',
    expanded: true,
    claimGroupName: EClaimsGroup.aceInsights,
    items: [
      {
        label: 'Manage Scorecards',
        routerLink: `/${ROOT_ROUTES.aceInsights}/${INSIGHTS_ROOT_ROUTES.configuration}/${INSIGHTS_CONFIGURATION_ROUTES.manageScorecards}`,
        claimName: ACE_INSIGHTS_CLAIMS.ACEInsightsScorecardAdminRead,
      },
      {
        label: 'Manage Conversation Insights',
        routerLink: `/${ROOT_ROUTES.aceInsights}/${INSIGHTS_ROOT_ROUTES.configuration}/${INSIGHTS_CONFIGURATION_ROUTES.manageConversationInsights}`,
        claimName: ACE_INSIGHTS_CLAIMS.ACEInsightsConversationInsightsRulesRead,
      },
    ],
  },
  {
    label: 'System',
    expanded: true,
    claimGroupName: EClaimsGroup.aceInsights,
    items: [
      {
        label: 'AP Pretrained Questions',
        routerLink: `/${ROOT_ROUTES.aceInsights}/${INSIGHTS_ROOT_ROUTES.system}/${INSIGHTS_SYSTEM_ROUTES.pretrainedQuestions}`,
        claimName: ACE_INSIGHTS_CLAIMS.ACEInsightsPretrainedQuestionsRead,
      },
      {
        label: 'CI System Rules',
        routerLink: `/${ROOT_ROUTES.aceInsights}/${INSIGHTS_ROOT_ROUTES.system}/${INSIGHTS_SYSTEM_ROUTES.ciSystemRules}`,
        claimName: ACE_INSIGHTS_CLAIMS.ACEInsightsCISystemRulesRead,
      },
    ],
  },
  {
    label: 'Conversations',
    expanded: true,
    claimGroupName: EClaimsGroup.conversations,
    items: [
      {
        label: 'Conversations Insights',
        expanded: true,
        claimGroupName: EClaimsGroup.conversations,
        items: [
          {
            label: 'Conversations',
            routerLink: `/${ROOT_ROUTES.aceInsights}/${INSIGHTS_ROOT_ROUTES.reports}/${INSIGHTS_REPORTS_ROUTES.conversations}`,
            claimName: ACE_INSIGHTS_CLAIMS.ConversationsViewerAdminRead,
          },
          {
            label: 'Resident Reasons for Calling',
            routerLink: `/${ROOT_ROUTES.aceInsights}/${INSIGHTS_ROOT_ROUTES.reports}/${INSIGHTS_REPORTS_ROUTES.residentCallReasons}`,
            claimName: ACE_INSIGHTS_CLAIMS.ConversationsViewerAdminRead,
          },
          {
            label: 'Agent Action Items',
            routerLink: `/${ROOT_ROUTES.aceInsights}/${INSIGHTS_ROOT_ROUTES.reports}/${INSIGHTS_REPORTS_ROUTES.agentActions}`,
            claimName: ACE_INSIGHTS_CLAIMS.ConversationsViewerAdminRead,
          },
        ],
      },
      {
        label: 'Agent Performance',
        expanded: true,
        claimGroupName: EClaimsGroup.conversations,
        items: [
          {
            label: 'Scorecard Conversations',
            routerLink: `/${ROOT_ROUTES.aceInsights}/${INSIGHTS_ROOT_ROUTES.reports}/${INSIGHTS_REPORTS_ROUTES.scorecardConversations}`,
            claimName: ACE_INSIGHTS_CLAIMS.ConversationsViewerAdminRead,
          },
          {
            label: 'Question Performance',
            routerLink: `/${ROOT_ROUTES.aceInsights}/${INSIGHTS_ROOT_ROUTES.reports}/${INSIGHTS_REPORTS_ROUTES.questionPerformance}`,
            claimName: ACE_INSIGHTS_CLAIMS.ConversationsViewerAdminRead,
          },
          {
            label: 'Site Ranking',
            routerLink: `/${ROOT_ROUTES.aceInsights}/${INSIGHTS_ROOT_ROUTES.reports}/${INSIGHTS_REPORTS_ROUTES.siteRanking}`,
            claimName: ACE_INSIGHTS_CLAIMS.ConversationsViewerAdminRead,
          },
          {
            label: 'Agent Ranking',
            routerLink: `/${ROOT_ROUTES.aceInsights}/${INSIGHTS_ROOT_ROUTES.reports}/${INSIGHTS_REPORTS_ROUTES.agentRanking}`,
            claimName: ACE_INSIGHTS_CLAIMS.ConversationsViewerAdminRead,
          },
          {
            label: 'Scorecard Challenges',
            routerLink: `/${ROOT_ROUTES.aceInsights}/${INSIGHTS_ROOT_ROUTES.reports}/${INSIGHTS_REPORTS_ROUTES.scorecardChallenges}`,
            claimName: ACE_INSIGHTS_CLAIMS.ConversationsViewerAdminRead,
          },
        ],
      },
    ],
  },
];
